var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputComponent',_vm._b({},'InputComponent',_vm.$attrs,false),[_c('RichTextComponent',{attrs:{"disabled":_vm.$attrs.disabled,"commands":_vm.$attrs.commands},model:{value:(_vm.comp),callback:function ($$v) {_vm.comp=$$v},expression:"comp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }